export enum RetentionUnit {
    Days = "Days",
    Items = "Items",
}

export enum RetentionPeriodStrategy {
    Count = "Count",
    Default = "Default",
    Forever = "Forever",
}

export enum ReleaseRetentionPolicyType {
    Count = "Count",
    Default = "Default",
    Forever = "Forever",
}

export enum TentacleRetentionPolicyType {
    Count = "Count",
    Default = "Default",
    Forever = "Forever",
}

export interface RetentionPeriod {
    Strategy: RetentionPeriodStrategy;
    QuantityToKeep: number;
    ShouldKeepForever: boolean;
    Unit: RetentionUnit;
}

export interface RunbookRetentionPolicy {
    QuantityToKeep: number;
    ShouldKeepForever: boolean;
    Unit: RetentionUnit;
    Strategy: RetentionPeriodStrategy;
}

// New polymorphic retention policy interfaces
export interface BaseRetentionPolicy {
    Type: string;
}

export interface CountBasedRetentionPolicy extends BaseRetentionPolicy {
    Type: "Count";
    QuantityToKeep: number;
    Unit: RetentionUnit;
}

export interface DefaultRetentionPolicy extends BaseRetentionPolicy {
    Type: "Default";
}

export interface ForeverRetentionPolicy extends BaseRetentionPolicy {
    Type: "Forever";
}

export type ReleaseRetentionPolicy = CountBasedRetentionPolicy | DefaultRetentionPolicy | ForeverRetentionPolicy;
export type TentacleRetentionPolicy = CountBasedRetentionPolicy | DefaultRetentionPolicy | ForeverRetentionPolicy;
